// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"eb712b6a","648":"03cce5b9"}[chunkId] + ".chunk.js";
};